// export const GREY = '#e6e9eB'
// export const GREEN = '#367070'
// export const PURPLE = '#4b4776'



// export const PURPLUSH = "#9929baaa"

// New Brand Color Palette
// Blue palette (for primary brand)
export const UTILITIES_BLACK ="#0A0A0A"
export const BRAND_BLUE = '#0069EB'
export const BRAND_BLUE_LIGHT = '#6FAAFF'
export const BRAND_BLUE_LIGHTEST = '#B1D5FF'

// Forest green palette (for first choice)
export const FOREST_GREEN_DARK = '#496866'
export const FOREST_GREEN_MEDIUM = '#85A6A4'
export const FOREST_GREEN_LIGHT = '#B0D0CF'

// Mint green palette (for recommending)
export const MINT_GREEN_DARK = '#356A42'
export const MINT_GREEN_MEDIUM = '#5E9469'
export const MINT_GREEN_LIGHT = '#B8DDBE'

// Purple palette
export const BRAND_PURPLE_DARK = '#6E5996'
export const BRAND_PURPLE_MEDIUM = '#B49FE2'
export const BRAND_PURPLE_LIGHT = '#D6CAF4'

// Gray palette
export const BRAND_GRAY_DARK = '#5D5D5D'
export const BRAND_GRAY_MEDIUM = '#B4B4B4'
export const BRAND_GRAY_LIGHT = '#D2D2D2'

// export const LIGHTER_GREEN = '#69A3A3'

// export const DARKER_GREY = '#808385'

// export const DARKER_GREEN = '#033D3D'

// Wine/Red palette - CHOOSE YOUR OPTION (1, 2, 3, or 4)
const WINE_OPTION = 4; // Change to 1, 2, 3, or 4 to test different palettes

// Option 1: Purple/Magenta Variants (warmer purples)
const WINE_OPTION_1 = {
  WHINE_RED: '#8B4A8B',           // Warm purple/magenta
  LIGHTER_WHINE_RED: '#B876B8',   // Light mauve
  DARKER_WHINE_RED: '#5A2D5A',    // Dark plum
};

// Option 2: Olive/Sage Green Variants (yellow-green tones)
const WINE_OPTION_2 = {
  WHINE_RED: '#6B7547',           // Olive green
  LIGHTER_WHINE_RED: '#8FA368',   // Sage green
  DARKER_WHINE_RED: '#3D4428',    // Dark olive
};

// Option 3: Blue-Purple/Periwinkle (between blue & purple)
const WINE_OPTION_3 = {
  WHINE_RED: '#6B5B95',           // Blue-purple
  LIGHTER_WHINE_RED: '#9B8BC4',   // Light periwinkle
  DARKER_WHINE_RED: '#3D2F5A',    // Dark indigo-purple
};

// Option 4: Warm Earthy Tones (terracotta, amber, chocolate)
const WINE_OPTION_4 = {
  WHINE_RED: '#A67B5B',           // Terracotta/Warm brown
  LIGHTER_WHINE_RED: '#C4A35A',   // Golden amber
  DARKER_WHINE_RED: '#6B4423',    // Chocolate brown
};

// Select active option
const ACTIVE_WINE_PALETTE = WINE_OPTION === 1 ? WINE_OPTION_1 : WINE_OPTION === 2 ? WINE_OPTION_2 : WINE_OPTION === 3 ? WINE_OPTION_3 : WINE_OPTION_4;
const SECONDARY_WINE_PALETTE = WINE_OPTION === 1 ? WINE_OPTION_2 : WINE_OPTION === 2 ? WINE_OPTION_3 : WINE_OPTION === 3 ? WINE_OPTION_4 : WINE_OPTION_1;
// Export selected wine colors
export const WHINE_RED = ACTIVE_WINE_PALETTE.WHINE_RED;
export const LIGHTER_WHINE_RED = ACTIVE_WINE_PALETTE.LIGHTER_WHINE_RED;
export const DARKER_WHINE_RED = ACTIVE_WINE_PALETTE.DARKER_WHINE_RED;

// Warm accent colors - amber/orange tones
export const BRUNISH = SECONDARY_WINE_PALETTE.WHINE_RED;
export const REDISH = SECONDARY_WINE_PALETTE.LIGHTER_WHINE_RED;
// Cool accent - teal
export const NEON_BLUE = SECONDARY_WINE_PALETTE.DARKER_WHINE_RED;

// Deep purple - very dark state
//SHOULD BE THE DARKER WINE COLOR of the non selected option
export const DARKER_PURPLE = WINE_OPTION === 1 ? WINE_OPTION_3.DARKER_WHINE_RED : WINE_OPTION === 2 ? WINE_OPTION_3.DARKER_WHINE_RED : WINE_OPTION === 3 ? WINE_OPTION_1.DARKER_WHINE_RED : WINE_OPTION_1.DARKER_WHINE_RED;
export const LIGHTER_PURPLE = "#D6CAF4"
// Text colors
export const TEXT_GRAY = BRAND_GRAY_DARK // #5D5D5D - for chart legends and text

